import { captureException } from '@sentry/react';
import { asError } from './as-error';

export const traceError: typeof captureException = (exception, hint) => {
  const error = asError(exception);
  console.error(error);
  return captureException(error, hint);
};
